import { render, staticRenderFns } from "./DashInicialVarejo.vue?vue&type=template&id=730aadb6&"
import script from "./DashInicialVarejo.vue?vue&type=script&lang=js&"
export * from "./DashInicialVarejo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports